var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import { json } from 'overmind';
import Slider from 'components/Slider.vue';
import Input from 'components/Input.vue';
import { mixpanelTracking } from '@/services/mixpanel';
import { differenceBetweenCnpjAndCompanyTooltip, formatNumber, } from '@/shared/utils/helpers';
import { overmind, connect } from '@/overmind';
import { SearchStatus } from '@/overmind/search/state';
let Employees = class Employees extends Vue {
    constructor() {
        super(...arguments);
        this.selectedInputValue = json(this.selectedInputRange);
        this.sliderValue = json(this.stateSliderFiltersValues.employees);
        this.radioButtonValue = this.radioButton;
        this.showOptionInput = false;
        this.inputValueInitial = null;
        this.inputValueEnd = null;
        this.hasError = false;
    }
    mounted() {
        // toda a logica abaixo serve para a interface saber qual tipo de input renderizar ao carregar uma busca
        // se os valores do intervalo forem compatíveis com os valores do slider, então renderiza o slider,
        // do contrário ele irá renderizar os inputs.
        if (this.selectedInputValue) {
            const initialValue = this.getInitialSelectedInputRange(this.selectedInputValue, 'value_start');
            const endValue = this.getInitialSelectedInputRange(this.selectedInputValue, 'value_end');
            if (endValue) {
                this.inputValueEnd = endValue;
            }
            const sliderLabels = overmind.state.filters.stateSliderFilters.employees.label || [];
            if (sliderLabels.includes(`${initialValue}`) &&
                sliderLabels.includes(`${endValue}`)) {
                this.showOptionInput = false;
            }
            else {
                this.showOptionInput = true;
            }
        }
    }
    setInputValueInitial(value) {
        this.inputValueInitial = Number(value) || null;
        if (this.$refs.employeeInputInitial) {
            //@ts-ignore
            this.$refs.employeeInputInitial.$refs.qinput.validate();
            //@ts-ignore
            this.$refs.employeeInputEnd.$refs.qinput.validate();
        }
        this.selectedInputValue[this.radioButton].value_start =
            this.inputValueInitial;
        this.selectedInputValue[this.radioButton].value_end = this.inputValueEnd;
        if (this.inputValueInitial <= this.inputValueEnd) {
            this.hasError = false;
            this.setInputRange({
                value_start: this.inputValueInitial,
                value_end: this.inputValueEnd,
                queryField: this.radioButton,
            });
        }
        else {
            this.hasError = true;
        }
    }
    setInputRange(inputsSelectedValues) {
        overmind.actions.search.searches.buildPotentialResults();
        overmind.actions.filters.setInputRange({
            ...inputsSelectedValues,
            groupTag: 'porte',
        });
    }
    setInputValueEnd(value) {
        this.inputValueEnd = Number(value) || null;
        if (this.$refs.employeeInputEnd) {
            //@ts-ignore
            this.$refs.employeeInputInitial.$refs.qinput.validate();
            //@ts-ignore
            this.$refs.employeeInputEnd.$refs.qinput.validate();
        }
        this.selectedInputValue[this.radioButton].value_start =
            this.inputValueInitial;
        this.selectedInputValue[this.radioButton].value_end = this.inputValueEnd;
        if (this.inputValueInitial <= this.inputValueEnd) {
            this.hasError = false;
            this.setInputRange({
                value_start: this.inputValueInitial,
                value_end: this.inputValueEnd,
                queryField: this.radioButton,
            });
        }
        else {
            this.hasError = true;
        }
    }
    setSelectedRadioButton(queryField, from) {
        overmind.actions.search.searches.buildPotentialResults();
        overmind.actions.search.setRadioButtonState(SearchStatus.RECEIVING);
        overmind.actions.filters.setSelectedRadioButton({ from, queryField });
        if (this.selectedInputValue[queryField]) {
            this.selectedInputValue[queryField].value_start = this.inputValueInitial;
            this.selectedInputValue[queryField].value_end = this.inputValueEnd;
        }
        if (queryField === 'total_employees_r2016_company' ||
            queryField === 'total_employees_r2016_cnpj') {
            if (this.inputValueInitial && this.inputValueEnd) {
                this.setInputRange({
                    value_start: this.selectedInputValue[queryField].value_start,
                    value_end: this.selectedInputValue[queryField].value_end,
                    queryField: queryField,
                });
            }
        }
    }
    validSliderFilter({ value }) {
        if (value[0] === value[1]) {
            overmind.actions.filters.setErrorSlider({
                type: this.filter.groupTag,
                action: 'error',
            });
            this.setSliderFilter(value);
        }
        else {
            overmind.actions.filters.setErrorSlider({
                type: this.filter.groupTag,
                action: 'success',
            });
            if (value[0] !== value[1] && value[1] !== '0') {
                this.inputValueInitial = null;
                this.inputValueEnd = null;
                if (value[1] === '+500')
                    value[1] = '10000000';
                this.setInputRange({
                    value_start: value[0],
                    value_end: value[1],
                    queryField: this.radioButtonValue,
                });
                this.setSliderFilter(value);
            }
        }
    }
    setSliderFilter(value) {
        overmind.actions.search.searches.buildPotentialResults();
        overmind.actions.filters.setSliderFilters({
            groupTagFilter: this.filter.groupTag,
            queryField: this.filter.queryField,
            value,
        });
    }
    get selectedInfo() {
        if (this.selected)
            if (!this.hasError) {
                if (this.inputValueInitial && this.inputValueEnd)
                    return `(selecionado: ${formatNumber(this.inputValueInitial)} a ${formatNumber(this.inputValueEnd)})`;
                else if (this.sliderValue.value.length > 0)
                    return `(selecionado: ${this.sliderValue.value[0]} a ${this.sliderValue.value[1]})`;
                return 'selecionado';
            }
            else
                return '<span class="font-12 text-red-8 text-weight-bold">Erro no filtro</span>';
        return '';
    }
    getSliderStyle() {
        if (this.errorSlider) {
            return {
                color: 'red',
            };
        }
    }
    tooltipCopy(label) {
        return differenceBetweenCnpjAndCompanyTooltip(label);
    }
    onSelectedInputRangeChange(curr, old) {
        if (curr) {
            const initialValue = this.getInitialSelectedInputRange(curr, 'value_start');
            if (initialValue !== undefined)
                this.inputValueInitial = initialValue;
            const endValue = this.getInitialSelectedInputRange(curr, 'value_end');
            if (endValue !== undefined)
                this.inputValueEnd = endValue;
            // a logica abaixo serve para que ao digitar os 2 inputs, caso ambos os valores sejam compativeis
            // com as opções do slider, ele deve setar também o estado do slider, para que ao fechar e abrir
            // o modal de filtros novamente, seja renderizado o slider e com o valor correto.
            const sliderLabels = overmind.state.filters.stateSliderFilters.employees.label || [];
            if (sliderLabels.includes(`${initialValue}`) &&
                sliderLabels.includes(`${endValue}`)) {
                this.setSliderFilter([`${initialValue}`, `${endValue}`]);
            }
        }
    }
    getInitialSelectedInputRange(inputRange, valuePosition) {
        if (inputRange) {
            if (this.$refs.employeeInputInitial || this.$refs.employeeInputEnd) {
                //@ts-ignore
                this.$refs.employeeInputInitial.$refs.qinput.validate();
                //@ts-ignore
                this.$refs.employeeInputEnd.$refs.qinput.validate();
            }
            const value = inputRange[this.radioButtonValue][valuePosition];
            return value === null ? null : Number(json(value));
        }
        else {
            return null;
        }
    }
    clearFilter() {
        this.inputValueInitial = null;
        this.inputValueEnd = null;
        this.showOptionInput = true;
        //@ts-ignore
        this.actions.filters.clearInputRangeFilter({
            queryField: this.radioButtonValue,
            groupTag: 'porte',
        });
    }
    toggleMode() {
        this.showOptionInput = !this.showOptionInput;
    }
    handleTrackingEmployees() {
        mixpanelTracking('filtros avançados: Expandiu o grupo de filtros: ' + this.filterName);
    }
};
__decorate([
    Prop({ default: () => { } })
], Employees.prototype, "filter", void 0);
__decorate([
    Prop({ default: () => { } })
], Employees.prototype, "stateSliderFiltersValues", void 0);
__decorate([
    Prop({ default: () => { } })
], Employees.prototype, "selectedInputRange", void 0);
__decorate([
    Prop({ default: '' })
], Employees.prototype, "filterName", void 0);
__decorate([
    Prop({ default: '' })
], Employees.prototype, "radioButton", void 0);
__decorate([
    Prop({ default: false })
], Employees.prototype, "errorSlider", void 0);
__decorate([
    Prop({ default: 0 })
], Employees.prototype, "selected", void 0);
__decorate([
    Watch('selectedInputValue', { immediate: true, deep: true })
], Employees.prototype, "onSelectedInputRangeChange", null);
Employees = __decorate([
    Component(connect(({ actions }) => ({ actions: actions }), {
        components: { Slider, Input },
    }))
], Employees);
export default Employees;
